import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["toggleButton", "cell"]
  static values = {
    mode: { type: String, default: "index" }
  }

  connect() {
    this.updateDisplay()
  }

  toggle(event) {
    const button = event.currentTarget
    this.toggleButtonTargets.forEach(btn => btn.classList.remove('selected'))
    button.classList.add('selected')
    this.modeValue = button.dataset.mode
    this.updateDisplay()
  }

  updateDisplay() {
    this.cellTargets.forEach(cell => {
      const v = cell.dataset.v
      const y = cell.dataset.y
      const value = this.modeValue === 'tce' ?
        this.formatTce(cell.dataset.tce) :
        `${Math.round(cell.dataset.index)}%`
      cell.textContent = value
    })
  }

  formatTce(value) {
    return Math.round(value).toString()
  }
}
